<template>
  <div id="template">
    <aside class="aside">
      <app-sidebar-header class="sidebar-header"></app-sidebar-header>
      <div class="sidebar">
        <ul class="list-unstyled" v-bind:class="[isActive ? 'up' : 'down']">
          <li><a href="https://diu.ac/" target="_blank" id="">DIU Home</a></li>
          <li>
            <router-link class="text-white" to="/">Home</router-link>
          </li>
          <li>
            <a href="#PersonalInformation" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#PersonalInformation`
              ? 'is-active'
              : ''
              ">Personal Information</a>
          </li>
          <li v-if="results.academic_qualifications.length">
            <a href="#AcademicQualification" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#AcademicQualification`
              ? 'is-active'
              : ''
              ">Academic Qualification</a>
          </li>
          <li v-if="results.training_experience.length">
            <a href="#TrainingExperience" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#TrainingExperience`
              ? 'is-active'
              : ''
              ">Training Experience</a>
          </li>
          <li v-if="results.area_of_skills.length">
            <a href="#TeachingArea" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#TeachingArea`
              ? 'is-active'
              : ''
              ">Teaching Area</a>
          </li>
          <li v-if="results.publications.length">
            <a href="#Publication" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#Publication`
              ? 'is-active'
              : ''
              ">Publication</a>
          </li>
          <li v-if="results.awards.length">
            <a href="#AwardScholarship" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#AwardScholarship`
              ? 'is-active'
              : ''
              ">Award & Scholarship</a>
          </li>
          <li v-if="results.memberships.length">
            <a href="#Membership" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#Membership`
              ? 'is-active'
              : ''
              ">Membership</a>
          </li>
          <li v-if="results.employment.length">
            <a href="#PreviousEmployment" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#PreviousEmployment`
              ? 'is-active'
              : ''
              ">Previous Employment</a>
          </li>
          <li v-if="results.expart_on.length">
            <a href="#ExpartOn" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#ExpartOn`
              ? 'is-active'
              : ''
              ">Expert On</a>
          </li>
          <li v-if="results.counseling_hour.length">
            <a href="#CounsellingHour" :class="`${this.$route.fullPath}` ==
              `/${$route.params.slug}#CounsellingHour`
              ? 'is-active'
              : ''
              ">Counselling Hour</a>
          </li>
          <li v-if="results.relGallery.length">
            <a href="#Gallery" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#Gallery`
              ? 'is-active'
              : ''
              ">Gallery</a>
          </li>
          <li>
            <a href="#Rating" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#Rating`
              ? 'is-active'
              : ''
              ">Rating</a>
          </li>
        </ul>
        <a class="toggle_drawer" href="javaScript:void(0);" @click="toggleClass()">
          <span>Menus</span>
          <i class="fas " v-bind:class="[isActive ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
        </a>
      </div>
      <app-sidebar-footer class="sidebar-footer"></app-sidebar-footer>
    </aside>
    <section class="entry">

      <article class="basic" id="PersonalInformation">
        <div class="overlay"></div>
        <div class="content">
          <div class="profile-photo">
            <v-lazy-image class="mx-auto d-block" :src="'//api.diu.ac/' + results.profile_photo_file"
              :alt="results.name" />
          </div>
          <h1 class="text-white">{{ results.name }}</h1>
          <h3 class="text-white">{{ results.designation }}</h3>
          <p class="text-white font-we text-justify">{{ results.overview }}</p>
          <!-- <div class="d-flex justify-content-center align-items-center mt-2">
            <star-rating
              :rating="parseInt(results.average_rating)"
              :star-size="25"
              :read-only="true"
              :animate="true"
              :glow="5"
              :showRating="false"
              :increment="0.01"
              :fixed-points="2"
              active-color="#FFA41C"
              inactive-color="#DFDFDE"
              border-color="#de7921"
              :border-width="1"
              glowColor="#FFA41C"
            />
            <h6 class="ml-2 text-dark">
              {{ results.average_rating }}/5 ({{
                results.total_rating_provider
              }})
            </h6>
          </div> -->
        </div>
      </article>

      <article class="contact">
        <h3>Contact Information</h3>
        <div class="row">
          <div class="col-md-12">
            <p>
              <span>Address:</span> {{ results.department }},
              {{ results.office_address }}
            </p>
          </div>
          <!-- <div class="col-md-4">
            <p>
              <span>Phone:</span>
              <a :href="`tel:${results.personal_phone_no}`">{{
                results.personal_phone_no
              }}</a>
            </p>
          </div> -->
          <div class="col-md-6">
            <p>
              <span>Email:</span>
              <a :href="`mailto:${results.office_email}`">{{
                results.office_email
              }}</a>
            </p>
          </div>
          <div class="col-md-6">
            <p><span>Campus:</span> {{ results.campus }}</p>
          </div>
        </div>
        <div class="socials" v-if="results.socials.length">
          <p><span>Social Contacts:</span></p>
          <ul class="list-inline">
            <li class="list-inline-item" v-for="(social, i) in results.socials" :key="i">

              <template v-if="social.name == 'WhatsApp'">
                <a :href="`https://api.whatsapp.com/send/?phone=${social.url}&text=Hello+Sir.++I+need+help.&app_absent=0`
                  " target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else-if="social.name == 'Skype'">
                <a :href="`skype:live:${social.url}?chat`" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else-if="social.name == 'WeChat'">
                <a :href="`weixin://weixin.qq.com/r/${social.url}`" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else-if="social.name == 'Viber'">
                <a :href="`viber://contact?number=${social.url}`" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else>
                <a :href="social.url" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>
            </li>
          </ul>
        </div>
      </article>
      <article class="accademic" id="AcademicQualification" v-if="results.academic_qualifications.length">
        <h3>Academic Qualifications</h3>
        <div class="row">
          <div v-for="(qualification, i) in results.academic_qualifications" :key="i" class="col-md-6">
            <div class="content">
              <p>
                {{ qualification.title }}
                <span v-if="qualification.major">(Major in {{ qualification.major }})</span>
              </p>
              <p>{{ qualification.institute }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="experience" id="TrainingExperience" v-if="results.training_experience.length">
        <h3>Training Experience</h3>
        <div v-for="(experience, i) in results.training_experience" :key="i" class="content">
          <p>{{ experience.title }} ({{ experience.institute }})</p>
        </div>
      </article>
      <article class="teaching-area" id="TeachingArea" v-if="results.area_of_skills.length">
        <h3>Teaching Area</h3>
        <div class="row">
          <div v-for="(skill, i) in results.area_of_skills" :key="i" class="col-md-6">
            <div class="content">
              <p>{{ skill.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="publication" id="Publication" v-if="results.publications.length">
        <h3>Publication</h3>
        <div v-for="(publication, i) in results.publications" :key="i" class="content">
          <p>
            <span>{{ publication.type }}</span>
          </p>
          <div v-html="publication.description"></div>
        </div>
      </article>
      <article class="award" id="AwardScholarship" v-if="results.awards.length">
        <h3>Award & Scholarship</h3>
        <div class="row">
          <div v-for="award in results.awards" class="col-md-6">
            <div class="content">
              <p>{{ award.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="membership" id="Membership" v-if="results.memberships.length">
        <h3>Membership</h3>
        <div class="row">
          <div v-for="(membership, i) in results.memberships" :key="i" class="col-md-6">
            <div class="content">
              <p>{{ membership.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="employment" id="PreviousEmployment" v-if="results.employment.length">
        <h3>Previous Employment</h3>
        <div v-for="(employment, i) in results.employment" :key="i" class="content">
          <p>{{ employment.position }} ({{ employment.institute }})</p>
          <p>
            {{ employment.from }} -
            <span style="color: #333" v-if="employment.to">{{
              employment.to
            }}</span>
            <span style="color: #333" v-else>Continue</span>
          </p>
        </div>
      </article>
      <article class="expart-on" id="ExpartOn" v-if="results.expart_on.length">
        <h3>Expert On</h3>
        <div class="row">
          <div v-for="expart_on in results.expart_on" class="col-md-6">
            <div class="content">
              <p>{{ expart_on.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="employment" id="CounsellingHour" v-if="results.counseling_hour.length">
        <h3>Counselling Hour</h3>
        <div v-for="(counseling_hour, i) in results.counseling_hour" :key="i" class="content">
          <p>
            {{ counseling_hour.day }} - {{ counseling_hour.time_from }} to
            {{ counseling_hour.time_to }}
          </p>
          <p>{{ counseling_hour.place }}</p>
        </div>
      </article>

      <article v-if="results.relGallery.length" class="gallery" id="Gallery">
        <h3>Gallery</h3>
        <div class="card-columns">
          <div v-for="(row, index) in results.relGallery" :key="index">
            <div class="card">

              <v-lazy-image class="card-img-top" :src="`${row.img_file}`" :alt="row.title" />

              <div class="card-body">
                <h5 class="card-title">{{ row.title }}</h5>
                <!--                <p class="card-text">Some quick example</p>-->
              </div>
            </div>
          </div>
        </div>
      </article>

      <!-- <article class="rating" v-if="ratingCategory.length > 0 && results && results.id" id="Rating">
        <h3>Rating Details</h3>
        <rating-row
          v-for="(category, i) in ratingCategory"
          :key="i"
          :category_id="category.id"
          :eid="results.id"
          :title="category.english_title"
          :total_rating_provider="results.total_rating_provider"
        />
      </article> -->
      <app-footer class="footer"></app-footer>
    </section>

  </div>
</template>

<script>
import SidebarHeader from "./components/SidebarHeader.vue";
import SidebarFooter from "./components/SidebarFooter.vue";
import Footer from "./components/Footer.vue";
import { socialIcons } from "./functions.js";
import VLazyImage from "v-lazy-image";
import StarRating from "vue-star-rating";
import RatingRow from "./components/RatingRow.vue";

export default {
  components: {
    "app-footer": Footer,
    "app-sidebar-header": SidebarHeader,
    "app-sidebar-footer": SidebarFooter,
    "v-lazy-image": VLazyImage,
    "star-rating": StarRating,
    "rating-row": RatingRow
  },
  data() {
    return {
      results: [],
      isActive: false,
      aws_url: "https://api.diu.ac/",
      ratingCategory: []
    };
  },
  name: "App",
  metaInfo() {
    return {
      meta: [
        {
          property: "og:image",
          content: this.aws_url + this.results.profile_photo_file
        }
      ]
    };
  },

  mounted() {
    var current = this;

    var slug = current.$route.params.slug;
    if (slug === 'professorsaifulislam') {
      this.$router.push("/sislamk");
    }

    axios
      .get("https://api.diu.ac/public/profile/" + slug)
      .then(function (response) {
        current.results = response.data.data;
        current.results.socials.map((social, key) => {
          current.results.socials[key].icon = socialIcons[social.name];
        });
        current.getRatingCategory();
      })
      .catch(function (error) { })
      .finally(function () { });
  },

  methods: {
    toggleClass(event) {
      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
    async getRatingCategory() {
      try {
        let res = await axios.get(
          `https://api.diu.ac/bapi/profile/rating-category?id=${this.results.id}`
        );
        if (res) {
          this.ratingCategory = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}

.vc-overview {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  text-align: left;
  margin-bottom: 10px;
}

.vc-desc {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/Single.vue